import useCurrentUser from "hooks/fragments/useCurrentUser";
import { ReactElement } from "react";

export default function OnboardHider({
  children,
}: {
  children: ReactElement;
}) {
  const { isLoggedIn, onboarded } = useCurrentUser((u) => {
    return {
      onboarded: u?.onboarded || false,
      isLoggedIn: u?.id > 0,
    };
  });


  if(!isLoggedIn) {
    return children;
  }

  // Can see this screen
  if (isLoggedIn && onboarded) {
    return children;
  }

  return <></>;
}
